const link_list = {
    routePath: 'ticketsystems',
    actionName: 'count',
    iconClass: 'fa-solid fa-ticket',
    title: 'Recent Active Ticket',
    note:'Please raise a ticket for requesting tailored support from RM',
    search: '',
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default {link_list }